import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import hogarImg from "../../assets/img/familyhome.png";
import { FaWhatsapp } from "react-icons/fa";

const Hogar = () => {
  return (
    <section className="hogar-section py-5">
      <Container className="pt-5 pb-5" fluid={"xxl"}>
        <Row className="align-items-center">
          <Col md={7} xxl={6} xs={12} className="mb-4 mb-md-0">
            <div className="ps-md-5 pe-md-5 ps-4 pe-2">
              <span className="badge-hogar">Hogar</span>
              <h2 className="titulo-hogar mt-3 mb-4">
                La tranquilidad de tu
                <br />
                familia comienza
                <br />
                protegiendo su hogar
              </h2>
              <p>
                No importa si eres inquilino, dueño o arrendador y tampoco en <br className="d-md-block d-none" /> dónde
                vivas…
                <strong> ¡nosotros te protegemos!</strong> Desde daños por
                <br className="d-md-block d-none" /> desastres naturales hasta accidentes cotidianos.
              </p>
              <p className="fw-semibold">
                No solo nos importa tu casa, también todo lo que has construido
                <br className="d-md-block d-none" /> y vivido dentro de ella.
              </p>
              <p>
                Si estás interesado, da clic aquí y permítenos asesorarte
                <br className="d-md-block d-none" /> mediante una llamada o videollamada.
              </p>
              <a
                href="https://api.whatsapp.com/send?phone=5215552030377&text=Hola%2C%20solicito%20informaci%C3%B3n%20detallada%20sobre%20la%20cobertura%20de%20Hogar.%20Vi%20la%20info%20en%20su%20Portal%20Web.%20%F0%9F%8C%90"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-danger d-inline-flex align-items-center gap-2 mt-3 boton-hogar"
              >
                <FaWhatsapp />
                Quiero comunicarme
              </a>
            </div>
          </Col>
          <Col md={5} xxl={6} className="text-center p-0 m-0">
            <img src={hogarImg} alt="Protección de hogar" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hogar;
